export default __webpack_public_path__ + "static/media/loading-icon.b80e2486.svg";